import { Quote } from "lucide-react";
import { motion } from "framer-motion";

const testimonials = [
  {
    name: "Dr. Sarah Chen",
    role: "Research Director",
    country: "Singapore → USA",
    image: "https://images.pexels.com/photos/12396627/pexels-photo-12396627.jpeg?auto=compress&cs=tinysrgb&w=200",
    text: "M2L connected me with a prestigious research fellowship at Stanford. Their global network opened doors I didn't know existed.",
  },
  {
    name: "Marcus Weber",
    role: "Executive MBA Graduate",
    country: "Germany → Global",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200",
    text: "The executive program transformed my leadership approach. The international cohort and cross-border projects were invaluable.",
  },
  {
    name: "Elena Rodriguez",
    role: "Tech Entrepreneur",
    country: "Brazil → USA",
    image: "https://images.pexels.com/photos/6077567/pexels-photo-6077567.jpeg?auto=compress&cs=tinysrgb&w=200",
    text: "From São Paulo to Silicon Valley - M2L made my entrepreneurial dreams possible through their accelerator partnerships.",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-[#060B19] relative overflow-hidden"
    >
      {/* Background elements */}
      <div className="absolute top-0 right-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[150px] pointer-events-none" />
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-secondary/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        {/* Section Header */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-sm uppercase tracking-widest font-semibold text-primary mb-4 block">
            Success Stories
          </span>
          <h2
            className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-white mb-6"
            data-testid="testimonials-heading"
          >
            Voices From Our Global Community
          </h2>
          <p className="text-lg text-white/60 leading-relaxed">
            Hear from professionals and students who have transformed their 
            careers through our global education network.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              data-testid={`testimonial-card-${index}`}
              className="relative glass-card rounded-2xl p-8 card-hover"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 left-8 w-10 h-10 bg-primary/20 rounded-lg flex items-center justify-center border border-primary/30">
                <Quote className="w-5 h-5 text-primary" />
              </div>

              {/* Text */}
              <p className="text-white/70 leading-relaxed mt-4 mb-8 italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover border-2 border-primary/30"
                />
                <div>
                  <h4 className="font-semibold text-white">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-primary">
                    {testimonial.role}
                  </p>
                  <p className="text-xs text-white/50">
                    {testimonial.country}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
